<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="900"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="确认"
    cancelText="取消"
  >
    <a-card
      style="width:100%"
      :tabList="tabList"
      :activeTabKey="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <div v-if="noTitleKey === 'tab1'">
        <a-input-search
          v-model="inputQuery"
          placeholder="请输入搜索内容"
          style="width: 200px; margin-bottom: 20px;"
          @search="onSearch"
          enterButton
        />
        <a-table
          ref="table"
          size="default"
          :filterMultiple="false"
          :rowKey="item => item.id"
          :columns="columns1"
          :dataSource="goodsList"
          :rowSelection="rowSelectionGoods"
          :scroll="{ y: 300 }"
          :pagination="goodsPagination"
          @change="handleTableChangeGoods"
          :loading="loading"
        >
          <span slot="name" slot-scope="val">
            <p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ val }}</p>
          </span>
          <span slot="image" slot-scope="val">
            <img :src="cdnImg(val)" class="thumbnail" />
          </span>
        </a-table>
      </div>
      <div v-if="noTitleKey === 'tab2'">
        <a-input-search
          v-model="inputQuery"
          placeholder="请输入搜索内容"
          style="width: 200px; margin-bottom: 20px;"
          @search="onSearch"
          enterButton
        />
        <a-table
          ref="table"
          size="default"
          :filterMultiple="false"
          :columns="columns2"
          :rowKey="item => item.id"
          :dataSource="activityList"
          :rowSelection="rowSelectionActivity"
          :scroll="{ y: 300 }"
          :pagination="activityPagination"
          @change="handleTableChangeActivity"
          :loading="loading"
        >
          <span slot="name" slot-scope="val">
            <p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ val }}</p>
          </span>
          <span slot="image" slot-scope="val">
            <img :src="cdnImg(val)" class="thumbnail" />
          </span>
        </a-table>
      </div>
    </a-card>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
export default {
  name: 'GoodsSelectModle',
  components: {
    STable
  },
  props: {
    matType: {
      type: String,
      default: 'radio'
    }
    // selectKeys: {
    //   type: Array,
    //   default: null
    // }
  },
  data() {
    return {
      visible: false,
      title: '选择商品',
      inputQuery: '',
      columns1: [
        {
          title: '商品名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '图片',
          dataIndex: 'coverUrl',
          scopedSlots: { customRender: 'image' }
        },
        // {
        //   title: '折扣价',
        //   dataIndex: 'discountPrice'
        // },
        {
          title: '原价',
          dataIndex: 'originalPrice'
        }
      ],
      columns2: [
        {
          title: '活动名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '图片',
          dataIndex: 'coverUrl',
          scopedSlots: { customRender: 'image' }
        }
      ],
      noTitleKey: 'tab1',
      tabList: [
        {
          key: 'tab1',
          tab: '商品',
          scopedSlots: { tab: 'customRender' }
        },
        {
          key: 'tab2',
          tab: '活动'
        }
      ],
      goodsPagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      },
      activityPagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      },
      loading: true,
      goodsList: [],
      activityList: [],
      queryParam: {
        page: 1,
        size: 10
      },
      productId: '',
      selectedRows: [],
      selectedGoodsRows: [],
      selectedActivityRows: [],
      radioSelectRows: [],
      selectKeys: []
    }
  },
  computed: {
    rowSelectionGoods() {
      return {
        type: this.matType,
        onChange: this.onGoodsChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name
          }
        })
      }
    },
    rowSelectionActivity() {
      return {
        type: this.matType,
        onChange: this.onActivityChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name
          }
        })
      }
    }
  },
  methods: {
    handleTableChangeGoods(pagination) {
      this.goodsPagination.current = pagination.current
      this.goodsPagination.pageSize = pagination.pageSize
      this.queryParam.page = pagination.current
      this.queryParam.size = pagination.pageSize
      this.getGoodsList()
    },
    handleTableChangeActivity(pagination) {
      this.activityPagination.current = pagination.current
      this.activityPagination.pageSize = pagination.pageSize
      this.queryParam.page = pagination.current
      this.queryParam.size = pagination.pageSize
      this.getActivityList()
    },
    // selectGoods(keys, selectedGoodsRows) {
    //   debugger
    //   this.selectKeys = keys
    //   this.selectedGoodsRows = selectedGoodsRows
    // },
    // 商品选中
    onGoodsChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      // this.productId = selectedRowKeys
      if (this.matType === 'radio') {
        this.selectedRows = []
      }
      this.selectedGoodsRows = this.selectedGoodsRows.concat(selectedRows.concat(this.selectedActivityRows))
      // const copySelectedGoodsRows = []
      // // 循环selectedGoodsRows 包含了活动跟商品
      // for (const item of this.selectedGoodsRows) {
      //   let isExcet = false
      //   for (const id of selectedRowKeys) {
      //     if (item.id === id) {
      //       isExcet = true
      //     }
      //   }
      //   if (isExcet) {
      //     copySelectedGoodsRows.push(item)
      //   }
      // }
      // this.selectedGoodsRows = copySelectedGoodsRows

      this.radioSelectRows = selectedRows
      // this.$forceUpdate()
    },
    // 活动选中
    onActivityChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      // this.productId = selectedRowKeys
      if (this.matType === 'radio') {
        this.selectedRows = []
      }
      this.selectedActivityRows = this.selectedActivityRows.concat(selectedRows.concat(this.selectedGoodsRows))
      this.radioSelectRows = selectedRows
      // this.$forceUpdate()
    },
    // 显示/隐藏
    show() {
      this.visible = true
      this.getGoodsList()
    },
    // 提交
    handleOk() {
      this.visible = false
      this.selectedRows = this.matType === 'radio' ? this.radioSelectRows : this.deteleObject(this.selectedActivityRows.concat(this.selectedGoodsRows))
      this.$emit('selectGoods', this.selectedRows)
      // 初始化
      // this.queryParam.inputQuery = ''
      this.inputQuery = ''
      this.queryParam.size = 10
      this.queryParam.page = 1
      this.noTitleKey = 'tab1'
      this.goodsPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.activityPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.selectKeys = []
      this.selectedRows = []
      this.selectedActivityRows = []
      this.selectedGoodsRows = []
      // this.$forceUpdate()
    },
    // 关闭
    handleCancel() {
      this.visible = false
      // 初始化
      this.productId = ''
      this.selectedRows = []
      // this.queryParam.inputQuery = ''
      this.inputQuery = ''
      this.queryParam.size = 10
      this.queryParam.page = 1
      this.noTitleKey = 'tab1'
      this.goodsPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.activityPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.selectKeys = []
      this.selectedRows = []
      this.selectedActivityRows = []
      this.selectedGoodsRows = []
      // this.$forceUpdate()
    },
    // 商品与活动tab之间切换
    onTabChange(key, type) {
      if (key === 'tab2') {
        this.queryParam.size = this.activityPagination.pageSize
        // this.queryParam.inputQuery = ''
        this.activityPagination.current = 1
        this.inputQuery = ''
        this.queryParam.page = 1
        this.getActivityList()
        // this.$forceUpdate()
      } else {
        this.queryParam.size = this.goodsPagination.pageSize
        this.goodsPagination.current = 1
        // this.queryParam.inputQuery = ''
        this.inputQuery = ''
        this.queryParam.page = 1
        this.getGoodsList()
        // this.$forceUpdate()
      }
      this[type] = key
    },
    async getGoodsList() {
      this.loading = true
      const params = {
        // name: this.queryParam.inputQuery,
        name: this.inputQuery,
        current: this.queryParam.page,
        size: this.queryParam.size
      }
      const res = await this.$http.get('/p/marketing/web/product/getProductList', { params })
      this.goodsList = res.records
      this.goodsPagination.pageSize = res.size
      this.goodsPagination.total = res.total
      this.loading = false
      this.$forceUpdate()
    },
    async getActivityList() {
      this.loading = true
      const params = {
        // name: this.queryParam.inputQuery,
        name: this.inputQuery,
        current: this.queryParam.page,
        size: this.queryParam.size
      }
      const res = await this.$http.get('/p/marketing/web/product/getActivityList', { params })
      this.activityList = res.records
      this.activityPagination.pageSize = res.size
      this.activityPagination.total = res.total
      this.loading = false
      this.$forceUpdate()
    },
    onSearch() {
      if (this.noTitleKey === 'tab1') {
        this.queryParam.page = 1
        this.queryParam.size = 10
        this.getGoodsList()
      } else {
        this.queryParam.page = 1
        this.queryParam.size = 10
        this.getActivityList()
      }
    },
    // 去除数组中重复的对象
    deteleObject(obj) {
      const uniques = []
      const stringify = {}
      for (let i = 0; i < obj.length; i++) {
        const keys = Object.keys(obj[i])
        keys.sort(function(a, b) {
          return Number(a) - Number(b)
        })
        let str = ''
        for (let j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j])
          str += JSON.stringify(obj[i][keys[j]])
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i])
          stringify[str] = true
        }
      }
      return uniques
    }
  }
}
</script>

<style lang="stylus" scoped>
.thumbnail {
  width: 50px;
  height: 50px;
}
</style>
